import React from 'react';
import { IconRender, InheritProps } from '../IconRender';

export function OneContentIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
        <rect x="1" y="1" width="48" height="78" rx="7" fill="#343434" stroke={color} strokeWidth="4"/>
        <path d="M43.9995 17.5007C43.9995 16.6723 44.6711 16.0007 45.4995 16.0007H47.9995V63.0007H45.4995C44.6711 63.0007 43.9995 62.3292 43.9995 61.5007V17.5007Z" fill="#D9D9D9"/>
        <path d="M6.06233 61.5C6.0635 62.3284 5.39288 63.001 4.56445 63.0021L2.06638 63.0057L1.99984 16.0057L4.49792 16.0022C5.32635 16.001 5.99887 16.6716 6.00004 17.5L6.06233 61.5Z" fill="#D9D9D9"/>
        <rect x="8.99951" y="16.0007" width="32" height="47" rx="1.5" fill="#D9D9D9"/>
        </>
      )}
    />
  );
}
